export default __webpack_public_path__ + "static/media/appStore.f353b280.png";